export class TaskVariantGroup {
	constructor() {
	}
} 
